module.exports = __webpack_public_path__ + "static/img/bg-fr.5ed58093.png";